// @petci/shared-ui — coherence primitives shared between web and mobile

export { PhaseTwoStub } from "./phase-two-stub";
export type { PhaseTwoStubProps } from "./phase-two-stub";
export {
  SERVICES_STUBS,
  REPORT_STUBS,
  SUPPORT_STUBS,
  MENU_STUBS,
  BILL_STUBS,
  featureStatus,
} from "./stub-catalog";
export type { StubAtom, StubStatus } from "./stub-catalog";
export {
  FIXTURE_REQUESTS,
  SR_STATUS_TOKENS,
  SR_TYPE_KEYS,
  generateSRNumber,
  generateOutageReportRefNumber,
} from "./service-requests";
export { OUTAGE_REPORTER_COPY } from "./outage-reporter-copy";
export type {
  ServiceRequest,
  ServiceRequestType,
  ServiceRequestStatus,
} from "./service-requests";
export {
  FIXTURE_PAYMENTS,
  PAYMENT_STATUS_TOKENS,
} from "./payment-history";
export type { PaymentRecord, PaymentStatus } from "./payment-history";
export {
  mergePaymentHistory,
  formatStoredMethod,
  NO_METHOD_LABEL,
} from "./payment-history-merge";
export type { StoredMethodSummary } from "./payment-history-merge";
export { useDemoSessionStore } from "./demo-store";
export type { AccountUpdateData, PaymentEntry } from "./demo-store";
export {
  useBillState,
  resolveBillState,
  isValidPaymentAmount,
  exceedsRemaining,
} from "./use-bill-state";
export type { BillState, BillStateInputs } from "./use-bill-state";

export { formatCurrency, formatDate, formatBillDueDate, billDueIso, formatKwh, greeting, formatMonth, formatMonthNameLong, formatEta, formatEtaLong, formatStormEta, formatCountdown } from "./format";
export { reanchorDemoDate } from "./demo-clock";
export { DEMO_BANNER_COPY, PRESENTER_HINT_COPY } from "./copy";
export { BRAND } from "./brand";
export { PERSONA_AVATAR_TOKENS } from "./persona-avatar";
export {
  OUTAGE_STATUS_TOKENS,
  ACTIVE_OUTAGE_STATUSES,
  isActiveOutage,
  countActiveOutages,
} from "./outage-status";
export type { OutageStatus } from "./outage-status";
export {
  MIN_FRAME_SPAN_DEG,
  boundsOfPoints,
  unionBounds,
  expandBounds,
  featureBoundsByProperty,
  outageMapFrame,
  boundsToCamera,
} from "./map-framing";
export type {
  LngLat,
  LngLatBounds,
  OutageMapFrameOptions,
  ViewportDp,
  CameraStop,
} from "./map-framing";
export {
  LOCALES,
  LOCALE_LABELS,
  LOCALE_NAMES,
  CLDR_TAG,
  localeToTag,
  createLocaleStore,
  makeUseT,
} from "./locale";
export type { Locale, LocaleState, TranslateParams } from "./locale";
export {
  enforceCitations,
  CITATION_FALLBACK_COPY,
} from "./citation-enforcer";
export {
  CITATION_TOKENS,
  CITATION_TOKEN_SET,
  buildCitation,
  resolveTokensInText,
} from "./citation-registry";
export type { CitationToken } from "./citation-registry";
export type { EnforceCitationsResult, CitationResult, CitationFailure } from "./citation-enforcer";
export {
  checkGatewayUrl,
  assertNotGateway,
  generateConfirmationNumber,
} from "./gateway-block-guard";
export type { GatewayCheckResult } from "./gateway-block-guard";
export { useAsyncState } from "./use-async-state";
export type { AsyncState, UseAsyncStateReturn } from "./use-async-state";
export { useReducedMotion } from "./use-reduced-motion";
export { useBillCycleLabel } from "./use-bill-cycle-label";
export { formatStubStatus } from "./format-stub-status";
export { formatCustomerType } from "./format-customer-type";
export { resolveContextualCard } from "./contextual-card";
export type { ContextualCardProps } from "./contextual-card";
export { useActiveStorm } from "./use-active-storm";
export type { ActiveStormResult, StormFixture } from "./use-active-storm";
export type { StubStatusDisplay } from "./format-stub-status";
export { useNow, nowOrFixed } from "./use-now";
export { useHurricaneSeason } from "./use-hurricane-season";
export { useHurricaneAnchor } from "./use-hurricane-anchor";
export { INSIGHTS_PER_PERSONA, P3_KITCHEN_ANOMALY_RECENCY } from "./insights";
export type { Insight } from "./insights";
export { HOME_CONTEXT_PER_PERSONA, USAGE_TREND } from "./home-context";
export type { HomeContextCard } from "./home-context";
export { homeCardPriority } from "./home-cards";
export type { HomeCardId, HomeCardEntry, HomeCardFlags } from "./home-cards";
export { resolveHomeAlerts } from "./home-alerts";
export type {
  HomeAlert,
  HomeAlertKind,
  HomeAlertTone,
  HomeAlertState,
  HomeAlertInputs,
} from "./home-alerts";
export { isHotelPersona, isPropertyManager, isResidentialPersona } from "./persona-predicates";
export { useDismissable } from "./use-dismissable";
export {
  calculateBillDeltaPct,
  calculateMeterKwh,
  calculateMeterCost,
  calculatePortfolioTotal,
  calculateEnergyCharge,
  calculateDemandCharge,
  calculateMeterSharePct,
} from "./bill-calculations";
